import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsModule } from '@ngxs/store';

import { DropDownModule } from '@bayclubs/drop-down';
import { BcRecurringModule } from '@bayclubs/recurring';

import { SharedModule } from '@shared/shared.module';

import { SpinnerModule } from '@bayclubs/spinner';
import { BayclubsUiCoreModule } from '@bayclubs/ui-core';
import { BayclubsUiDatePickerModule } from '@bayclubs/ui-date-picker';
import { BlockedSlotSaveState } from './+store/blocked-slot-save.state';
import { BlockedSlotSaveModalComponent } from './containers/blocked-slot-save-modal/blocked-slot-save-modal.component';


@NgModule({
    declarations: [BlockedSlotSaveModalComponent],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        BcRecurringModule,
        NgxsModule.forFeature([BlockedSlotSaveState]),
        NgxsFormPluginModule,
        SharedModule,
        DropDownModule,
        TranslateModule,
        BayclubsUiDatePickerModule,
        BayclubsUiCoreModule,
        SpinnerModule,
    ],
})
export class BlockedSlotSaveModule { }

export * from './+store/blocked-slot-save.actions';
export * from './models/blocked-slot-save-input.model';
export * from './services/blocked-slot-save-launcher.service';

